import { ChangeEvent, FC } from "react"
import Cell from "../Cell"
import TextField from "../TextField"
import { Icon, IconColor } from "@/components/shared/Icon"
import { fieldConfig } from "@/pages/ControlPanel/config"
import { Facility } from "@/types/facility"

type FacilityInfoKey = keyof Omit<Facility, "address">

export const FacilityInfo: FC<{
   id: Facility["id"]
   alerts: Facility["alerts"]
   isEditMode: boolean
   smallSize?: boolean
   className: string
   infoKey: string
   info: Facility[keyof Omit<Facility, "address" | "alerts">]
   onChange: (e: ChangeEvent<HTMLInputElement>) => void
   onClick?: () => void
   facilityFormState: Facility
}> = ({
   isEditMode,
   smallSize = false,
   info,
   alerts,
   infoKey,
   className,
   onChange,
   onClick,
   facilityFormState,
}) => {
   return (
      <span className={className}>
         <Cell
            {...(smallSize && {
               className: "customers-facilities-table__input--small",
            })}
            name={infoKey}
            value={
               facilityFormState[infoKey as FacilityInfoKey] !== undefined
                  ? (facilityFormState[infoKey as FacilityInfoKey] as string)
                  : (info as string)
            }
            isEditMode={isEditMode}
            readonly={infoKey !== "name"}
            {...(infoKey === "name" && {
               handleCellChange: (e) => {
                  onChange(e)
               },
            })}
            placeholder={fieldConfig[infoKey as FacilityInfoKey]?.placeholder}
         >
            <TextField
               name={infoKey}
               {...(!isEditMode &&
                  infoKey === "name" && {
                     onClick: onClick,
                  })}
            >
               {info}
            </TextField>
            {infoKey === "name" && alerts?.stale > 0 && (
               <Icon
                  name="alerts"
                  color={IconColor.CERISE}
                  size="20"
               />
            )}
         </Cell>
      </span>
   )
}
